import { Link as RouterLink } from 'react-router-dom';
import { Alert, Button, Card, CardContent, LinearProgress, Link, Stack, Typography } from '@mui/material';
import { useAICostQuery } from '../../hooks/useAICostQuery';
import { adminApi } from '../../providers/dataProvider';
import { costDateRange, readCostPeriod } from '../../utils/aiCostPeriod';
import { presentRecordedCost } from '../../utils/aiCostPresentation';
import { useAdminText } from '../shared/useAdminText';

const period = readCostPeriod(new URLSearchParams());
export function UserAICostCard({ userId }: { userId: string }) {
  const t = useAdminText();
  const query = useAICostQuery(['ai-costs', 'user', userId, period],
    () => adminApi.getAICostUserDetail(userId, costDateRange(period)));
  const cost = query.data && presentRecordedCost(query.data.totalCost, query.data.costCoverage?.allTime, t);
  return <Card data-testid="admin-user-ai-cost"><CardContent><Stack spacing={1.5}>
    <Typography variant="h6">{t('userAICost', 'AI cost')}</Typography>
    <Typography variant="body2" color="text.secondary">{t('userAICostPeriod', 'Current month · USD · attributed calls')}</Typography>
    {query.isPending && <LinearProgress aria-label={t('loadingCosts', 'Loading AI costs')} />}
    {query.isError && <Alert severity={query.data ? 'warning' : 'error'}>{query.accessDenied
      ? t('costDenied', 'Access to AI costs was denied.')
      : query.data ? t('costStale', 'Could not refresh. Showing the last successful result.') : t('costFailed', 'Could not load AI costs.')}</Alert>}
    {cost && <>
      <Link component={RouterLink} to={`/ai-costs/${userId}?period=month`} variant="h4" underline="hover">{cost.value}</Link>
      <Typography variant="caption" color="text.secondary">{cost.detail}</Typography>
    </>}
    <Stack direction="row" spacing={1}>
      <Button component={RouterLink} to={`/ai-costs/${userId}?period=month`}>{t('viewCostDetails', 'View cost details')}</Button>
      {query.isError && !query.accessDenied && <Button onClick={() => void query.refetch()} disabled={query.isFetching}>{t('retry', 'Retry')}</Button>}
    </Stack>
  </Stack></CardContent></Card>;
}
